import type { RouteObject } from "react-router-dom";
import LandingPage from "../pages/LandingPage";
import Customer from "../pages/CustomerLanding";
import Business from "../pages/BusinessLanding";
import ToggleCustomerorBusiness from "../pages/ToggleCustomerorBusiness";

export const publicRoutes: RouteObject[] = [
  { path: "/", element: <LandingPage /> },
  { path: "/login-choice", element: <ToggleCustomerorBusiness /> },
  { path: "/customer-landing", element: <Customer /> },
  { path: "/business", element: <Business /> },
];
